import React from "react";
import {CSSProperties} from "react";
import styles from "./VantageTitle.module.scss"
import {Routes} from "../../routing/routes";


const VantageTitle = ({clickable, style}: {clickable?: boolean, style?: CSSProperties}) => {


    const Title = ({style}: {style?: CSSProperties}) => <span className={styles.applicationTitle} style={style}>
        <span className={styles.boldTitle}>PPD™ Vantage™</span><span className={styles.slimTitle}> Real-World Data Analyzer</span>
    </span>

    if (clickable) {
        return <a className={styles.applicationTitleLink} href={Routes.Home}>
            <Title style={{fontSize: "24px", ...style}}/>
        </a>
    }
    return <Title style={style}/>

}

export default VantageTitle
